<template>
    <div class="container">
        <line-chart v-if="loaded" :chartdata="chartdata" :options="options" />
    </div>
</template>

<script>
import LineChart from './Chart.vue'
import axios from 'axios'
import { domain } from '../../services/Constants'

export default {
    components: { LineChart },
    data() {
        return {
            loaded: false,
            chartdata: {
                labels: [],
                datasets: [{
                    label: 'ข้อมูลจำนวนโครงร่างในแต่ละปี',
                    data: [],
                    backgroundColor: [
                        'rgba(255, 99, 132, 0.2)',
                        'rgba(54, 162, 235, 0.2)',
                        'rgba(255, 206, 86, 0.2)',
                        'rgba(75, 192, 192, 0.2)',
                        'rgba(153, 102, 255, 0.2)',
                        'rgba(255, 159, 64, 0.2)'
                    ],
                    borderColor: [
                        'rgba(255, 99, 132, 1)',
                        'rgba(54, 162, 235, 1)',
                        'rgba(255, 206, 86, 1)',
                        'rgba(75, 192, 192, 1)',
                        'rgba(153, 102, 255, 1)',
                        'rgba(255, 159, 64, 1)'
                    ],
                    borderWidth: 1
                }],
            },
            options: {
                legend: {
                    display: false,
                    labels: {
                        fontColor: 'rgb(255, 99, 132)'
                    }
                },
                animation: {
                    duration: 1000,
                },
                labels: false,
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }],
                    xAxes: [{
                        gridLines: {
                            offsetGridLines: true
                        }
                    }]
                }
            }
        }
    },
    async mounted() {
        this.loaded = false;
        try {
            const response = await axios.get(domain + '/api/get-research-number-by-year');
            for (let i in response.data) {
                this.chartdata.labels.push(i);
                this.chartdata.datasets[0].data.push(response.data[i]);
            }
            this.loaded = true
        } catch (e) {
            console.error(e)
        }
    }
}
</script>
